import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Route, Switch, Redirect } from 'react-router';

import _ from 'lodash';
import LoadingOverlay from 'react-loading-overlay';


import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { AlertModal } from './components/ErrorModal';

//Staff-relevant components 
import { StaffHome } from './components/staff/StaffHome';
import ViewAsStudent from "./components/staff/ViewAsStudent";

import { SupervisorForm } from './components/staff/supervisor/SupervisorForm';
import { SelectSupervisor } from './components/staff/supervisor/SelectSupervisor';

import { EmployerForm } from './components/staff/employer/EmployerForm';
import { SelectEmployer } from './components/staff/employer/SelectEmployer';

import { HolidayForm } from './components/staff/holiday/HolidayForm';
import { SelectHoliday } from './components/staff/holiday/SelectHoliday';

import { StudentForm } from './components/staff/student/StudentForm';
import { SelectStudent } from './components/staff/student/SelectStudent';

import { AccountForm } from './components/staff/account/AccountForm';
import { SelectAccount } from './components/staff/account/SelectAccount';
import { AccountStatusForm } from './components/staff/account/AccountStatusForm';

import { TimesheetForm } from './components/staff/timesheet/TimesheetForm';
import { SelectTimesheet } from './components/staff/timesheet/SelectTimesheet';

import { AllAccountsSummary } from './components/reports/AllAccountsSummary';
import { TimesheetByDateRange } from './components/reports/TimesheetByDateRange';
import { TimesheetByPayWeek } from './components/reports/TimesheetByPayWeek';
import { TimesheetByStudent } from './components/reports/TimesheetByStudent';
import { KronosReport } from './components/reports/KronosReport';
import { CertifyTimesheets } from './components/reports/CertifyTimesheets';
import { StudentMigration } from './components/reports/StudentMigration';

import EmailStudent from './components/staff/messaging/EmailStudent';
import SelectEmail from './components/staff/messaging/SelectEmail';
import ViewEmail from './components/staff/messaging/ViewEmail';

//Student-relevant component
import { StudentHome } from './components/student/StudentHome';
import SelectPayPeriod from './components/student/SelectPayPeriod';
import ListMessages from './components/student/ListMessages';

//Used by both student and staff 
import TimesheetSubmissionForm from './components/forms/TimesheetSubmissionForm';


class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
    }

    render() {

        //If user is not logged in, show the home page. ;
        if ( _.isEmpty(this.props.store.user)   ) {
            return (
                <Layout key="unloaded" store={this.props.store}>
                    <Switch>
                        <Route path='/' component={Home} />
                        {/*<Route path='/*'>
                            <Redirect to="/" />
                        </Route>*/}
                    </Switch>
                </Layout>
            )
        }

        if (this.props.store.loading && this.props.store.state !== "loaded" ) {
            return (
                <Layout key="loading" store={this.props.store}>
                    <LoadingOverlay
                        active={this.props.store.loading}
                        spinner
                        text='Loading...'
                    >                        
                        <Route path='/' component={Home} />
                    </LoadingOverlay>
                </Layout>
            );
        }

        //If the user is logged in, the data is loaded, and the user is an admin.  
        else if (this.props.store.user.isAdmin) {
            return (
                <Layout key="loaded" store={this.props.store}>
                    <LoadingOverlay
                        active={this.props.store.loading}
                        spinner
                        text='Loading...'
                    >
                        <AlertModal 
                            store={this.props.store}
                        ></AlertModal>


                        <Switch>
                            <Route exact path='/' render={(props) => (
                                <StaffHome {...props} store={this.props.store} />
                            )} />

                            {/* Most complex component, where students/staff submit entire timesheets + timestamps*/}
                            <Route exact path='/submission' render={(props) => (
                                <TimesheetSubmissionForm {...props} store={this.props.store} />
                            )} />


                            {/* New / Update Supervisor nav */ }
                            <Route exact path='/staff/Supervisor' render={(props) => (
                                <SupervisorForm {...props} store={this.props.store} key={"new"} mode="new" />
                            )} />
                            <Route exact path='/staff/Supervisor/:id' render={(props) => (
                                <SupervisorForm {...props} store={this.props.store} key={"edit"} mode="edit" />
                            )} />
                            <Route path='/staff/SelectSupervisor' render={(props) => (
                                <SelectSupervisor store={this.props.store} {...props} />
                            )} />

                            {/* New / Update Employer nav */ }
                            <Route exact path='/staff/Employer' render={(props) => (
                                <EmployerForm {...props} store={this.props.store} key={"new"} mode="new" />
                            )} />
                            <Route exact path='/staff/Employer/:id' render={(props) => (
                                <EmployerForm {...props} store={this.props.store} key={"edit"} mode="edit" />
                            )} />
                            <Route exact path='/staff/SelectEmployer' render={(props) => (
                                <SelectEmployer store={this.props.store} {...props} />
                            )} />

                            {/* New / Update Holiday nav */ }
                            <Route exact path='/staff/Holiday' render={(props) => (
                                <HolidayForm {...props} store={this.props.store} key={"new"} mode="new" />
                            )} />
                            <Route exact path='/staff/Holiday/:id' render={(props) => (
                                <HolidayForm {...props} store={this.props.store} key={"edit"} mode="edit" />
                            )} />
                            <Route exact path='/staff/SelectHoliday' render={(props) => (
                                <SelectHoliday store={this.props.store} {...props} />
                            )} />

                            {/* New / Update Student nav */ }
                            <Route exact path='/staff/Student' render={(props) => (
                                <StudentForm {...props} store={this.props.store} key={"new"} mode="new" />
                            )} />
                            <Route exact path='/staff/Student/:id' render={(props) => (
                                <StudentForm {...props} store={this.props.store} key={"edit"} mode="edit" />
                            )} />
                            <Route exact path='/staff/SelectStudent' render={(props) => (
                                <SelectStudent store={this.props.store} {...props} />
                            )} />

                            {/* New / Update Account nav */ }
                            <Route exact path='/staff/Account/' render={(props) => (
                                <AccountForm {...props} key={"new"} store={this.props.store} />
                            )} />
                            <Route exact path='/staff/Account/:id' render={(props) => (
                                <AccountForm {...props} key={"edit"} store={this.props.store} />
                            )} />
                            <Route exact path='/staff/SelectAccount' render={(props) => (
                                <SelectAccount store={this.props.store}   {...props} />
                            )} />
                            <Route exact path='/staff/AccountStatus/:id' render={(props) => (
                                <AccountStatusForm store={this.props.store} {...props} />
                            )} />

                            {/* New / Update Timesheet nav */ }
                            <Route exact path='/staff/SelectTimesheet' render={(props) => (
                                <SelectTimesheet store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/Timesheet/' render={(props) => (
                                <TimesheetForm store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/Timesheet/:id' render={(props) => (
                                <TimesheetForm store={this.props.store} {...props} />
                            )} />

                            {/* Staff reporting navigation */ }
                            <Route exact path='/staff/allAccountsSummary' render={(props) => (
                                <AllAccountsSummary store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/StudentMigration' render={(props) => (
                                <StudentMigration store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/timesheetByDateRange' render={(props) => (
                                <TimesheetByDateRange store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/timesheetByPayWeek' render={(props) => (
                                <TimesheetByPayWeek store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/timesheetByStudent' render={(props) => (
                                <TimesheetByStudent store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/KronosReport' render={(props) => (
                                <KronosReport store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/certifyTimesheets' render={(props) => (
                                <CertifyTimesheets store={this.props.store} {...props} />
                            )} />

                            {/* Staff messaging navigation */ }
                            <Route exact path='/staff/messageStudent' render={(props) => (
                                <EmailStudent store={this.props.store} {...props} />
                            )} />
                            <Route exact path='/staff/selectMessage' render={(props) => {
                                return (<SelectEmail store={this.props.store} {...props} />)
                            }} />
                            <Route exact path='/staff/Message/:id' render={(props) => (
                                <ViewEmail store={this.props.store} {...props} />
                            )} />

                            <Route exact path='/staff/viewAsStudent' render={(props) => (
                                <ViewAsStudent store={this.props.store} {...props} />
                            )} />
                        </Switch>
                </LoadingOverlay>
            </Layout>
             )
        }
        else {
            //This is a student.
            //Get user, see if it's valid. 
            return (
                <Layout store={this.props.store}>
                    <LoadingOverlay
                        active={this.props.store.loading}
                        spinner
                        text='Loading your content...'
                    >
                        <AlertModal
                            store={this.props.store}
                        ></AlertModal>
                        <Switch>
                            {/* Student navigation nav */}
                            <Route exact path='/' render={(props) => (
                                <StudentHome {...props} store={this.props.store} />
                            )} />

                            {/* Most complex component, where students/staff submit entire timesheets + timestamps*/}
                            <Route exact path='/submission' render={(props) => (
                                <TimesheetSubmissionForm {...props} store={this.props.store} />
                            )} />
                            
                            <Route exact path='/student/messages' render={(props) => (
                                <ListMessages {...props} store={this.props.store} />
                            )} />

                            <Route exact path='/student/:id' render={(props) => (
                                <SelectPayPeriod {...props} store={this.props.store}/>
                            )} />

                            </Switch>
                    </LoadingOverlay>
                </Layout>
            );
        }
    }
}

App = observer(App)

export default App;